import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import {
  CreativeLibraryFilterId,
  CreativeLibraryFilterPrefix,
  ImageMetadata,
  SortableField,
} from './types';
import { Delete16 } from 'ui/icons/aurora/16px/Delete16';

export const defaults = {
  maxBatchSize: 10,
  maxImgDimension: 1920, // full width of HD (1920 x 1080)
  maxFileSize: 20 * 1024 * 1024, // 20MB (20,971,520 bytes)
  pageSize: 20,
  sortBy: SortableField.UpdatedAt,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
};

export const defaultImgMetadata = {} as ImageMetadata;

export const FOLDER_ID_SEARCH_PARAM = 'folderId';
export const PAGE_SEARCH_PARAM = 'page';

export const CREATIVE_LIBRARY_FILTER_OPTIONS = [
  {
    label: 'File Type',
    id: CreativeLibraryFilterId.FileType,
    prefix: CreativeLibraryFilterPrefix.FileType,
    queryLabel: 'label',
    queryId: 'id',
    isNumber: false,
  },
  {
    label: 'File Size',
    id: CreativeLibraryFilterId.FileSize,
    prefix: CreativeLibraryFilterPrefix.FileSize,
    queryLabel: 'label',
    queryId: 'id',
  },
  {
    label: 'Uploaded by',
    id: CreativeLibraryFilterId.Creator,
    prefix: CreativeLibraryFilterPrefix.Creator,
    queryLabel: 'fullName',
    queryId: 'id',
  },
  {
    label: 'Modified by',
    id: CreativeLibraryFilterId.ModifiedBy,
    prefix: CreativeLibraryFilterPrefix.ModifiedBy,
    queryLabel: 'fullName',
    queryId: 'id',
  },
];
export const MODAL_DISPLAY_TEXT_FOR_DELETING_MAIN = {
  actionName: {
    verb: 'delete',
    adjective: 'deleted',
  },
  actionIcon: Delete16,
};

export const MODAL_DISPLAY_TEXT_FOR_DELETING_FOLDER = {
  ...MODAL_DISPLAY_TEXT_FOR_DELETING_MAIN,
  suffixText: 'This will also archive content inside folders.',
  itemTypeName: {
    singular: 'folder',
    plural: 'folders',
  },
};

export const MODAL_DISPLAY_TEXT_FOR_DELETING_ASSET = {
  ...MODAL_DISPLAY_TEXT_FOR_DELETING_MAIN,
  itemTypeName: {
    singular: 'image',
    plural: 'images',
  },
};

export const ALT_TEXT_MAX_LENGTH = 125;

export const ROOT_FOLDER_NAME = 'Overview';

export const MAX_FOLDER_NAME_LENGTH = 150;
